module.exports = __webpack_public_path__ + "img/uy.9fb3467.svg";